<template>
  <v-tab-item :value="$route.fullPath" class="pa-3">
    <v-toolbar flat height="90">
      <ExportLinks export-key="store-monthly-point-history" />

      <v-spacer></v-spacer>

      <v-col cols="12" sm="4" class="pa-0">
        <b-search-field></b-search-field>
      </v-col>
    </v-toolbar>

    <v-data-table
      :headers="headers"
      :items="monthlyPoints"
      :footer-props="{
        itemsPerPageOptions: [12],
        showCurrentPage: true,
        pageText: `${page * 12 - 11}-${
          page * 12 <= serverItemsLength ? page * 12 : serverItemsLength
        } ${translations.paginationText[lang]} ${serverItemsLength}`,
      }"
      :page.sync="page"
      :server-items-length="serverItemsLength"
      :loading="loading"
      class="b-outlined"
    >
      <template v-slot:item.edit="{ item }">
        <v-btn color="yellow darken-3" icon @click="myFunc(item)">
          <v-icon v-text="icons.mdiPencilOutline"></v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </v-tab-item>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import ExportLinks from '@/components/general/ExportLinks.vue';
import translations from '@/utils/translations/storePanel/history';

export default {
  name: 'MonthlyPoints',

  components: { ExportLinks },

  mixins: [translations],

  data() {
    return {
      page: +this.$route.query.page,
      exportCsvStatus: 1,
    };
  },

  computed: {
    ...mapState(['loading', 'serverItemsLength', 'superUser']),
    ...mapState('storePanel/history', ['monthlyPoints']),

    lang() {
      return this.$route.params.lang;
    },
    storeMode() {
      return this.$store.state.store?.display_mode || 'points';
    },
    permission() {
      return this.$store.state.permissions.history
        ? this.$store.state.permissions.history.monthly_points
        : this.superUser;
    },

    headers() {
      return [
        { text: this.translations.date[this.lang], value: 'date' },
        { text: this.translations.funded[this.lang], value: 'funded' },
        {
          text: this.translations.nonFunded[this.lang],
          value: 'non_funded',
        },
        {
          text: this.translations[`total_${this.storeMode}`][this.lang],
          value: 'total_points',
        },
      ];
    },

    query() {
      let query = '?';

      for (let key in this.$route.query) {
        query += `${key}=${this.$route.query[key]}&`;
      }

      return query.slice(0, query.length - 1);
    },
  },

  methods: {
    ...mapActions('storePanel/history', ['getMonthlyPoints']),
  },

  watch: {
    permission: {
      immediate: true,
      handler(val) {
        if (!val && !this.superUser) {
          this.$router.replace(`/${this.lang}/storePanel/forbidden-gateway`);
        }
      },
    },

    $route(val) {
      if (!val.query.page) {
        this.$router.replace({
          query: {
            page: 1,
            ...this.$route.query,
          },
        });
      }

      this.getMonthlyPoints(this.query);
    },

    page(page) {
      this.$router.replace({ query: { ...this.$route.query, page } });
    },
  },

  beforeCreate() {
    if (!this.$route.query.page) {
      this.$router.replace({
        query: {
          page: 1,
          ...this.$route.query,
        },
      });
    }
  },

  mounted() {
    this.getMonthlyPoints(this.query);
  },
};
</script>
